import React, { useState } from "react"
import { Link } from "react-router";
import axios from 'axios'

import useSWR, { mutate } from 'swr'
import fetch from 'isomorphic-unfetch'
const fetcher = url => fetch(url).then(r => r.json())


function AppsIndex(){
  // fetch the data from our api using swr react hooks/fetch
  // this will also keep the data up-to-date
  const { data, error } = useSWR('/api/apps', fetcher)
  const [showForm, setShowForm] = useState(false)

  const [bundle, setBundle] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [image, setImage] = useState('')

  const [errorMessage, setErrorMessage] = useState('')

  const [showJSON, setShowJSON] = useState(false)
  function toggleShowJSON(){
    setShowJSON(!showJSON)
  }

  const changeImage = (e) => {
    setImage(e.target.value)
  }

  const changeBundle = (e) => {
    setBundle(e.target.value)
  }

  const changeDisplayName = (e) => {
    setDisplayName(e.target.value)
  }

  function toggleForm(){
    console.log("running toggle form")
    setShowForm(!showForm)
  }

  function dontToggle(event){
    event.stopPropagation();
  }

  // TODO: turn these into components
  if (error) return <div className="loading"><p>Failed to load. The server is probably down.</p></div>
  if (!data) return <div className="loading"><p>Loading...</p></div>

  const handleUpload = () => {
    if(image === '' || displayName === '' || bundle === ''){
      setErrorMessage('Fields not set')
    } else {
      // we'll upload things here
      console.log("UPLOAD")
      setErrorMessage('')

      const formData = new FormData()
      formData.append('image', image)
      formData.append('displayName', displayName)
      formData.append('bundle', bundle)

      const endpoint = '/api/apps'
      axios.post(endpoint, formData, {}).then(res => {
        console.log(res)
        // reset the form/reload the versions list
        setImage('')
        setDisplayName('')
        setBundle('')
        setErrorMessage('')
        setShowForm(false)

        // tell swr to refresh any data using this endpoint
        mutate('/apps')

      }).catch(err => {
        console.log(err)
      })

    }
  }

  return (
    <div>
      <h1>Apps <button className="inline-control-small inline-right" onClick={toggleForm}><span>+</span></button></h1>

      <div className="form" style={{ display: (showForm ? "block" : "none")}}  onClick={toggleForm}>
        <div className="form-modal" onClick={dontToggle} >
          <h3>New App</h3>
          <p>Enter New App Details</p>
          <p className='error-message'><b><i>{errorMessage}</i></b></p>
          <p><input type="text" value={displayName} placeholder="App Display Name" name="displayName" onChange={changeDisplayName}></input></p>
          <p><input type="text" value={bundle} placeholder="com.company.packagename" name="bundle" onChange={changeBundle}></input></p>
          <p><input type="text" value={image} placeholder="App Image URL" onChange={changeImage}></input></p>
          <p><input type='submit' value='Upload' onClick={handleUpload} /></p>
        </div>
      </div>

      <div className="grid">
        <AppList apps={data} />
      </div>

      <div>
        <h1>JSON OUTPUT <button className="inline-control-small" onClick={toggleShowJSON}><span>{showJSON ? "hide" : "show"}</span></button></h1>
        <pre className={showJSON ? "" : "hidden"}>{JSON.stringify(data, null, 3)}</pre>
      </div>
    </div>
  )
}

function AppList(props){
  // map the data to JSX
  const apps = props.apps.map(app => (
    <Link to={ "/app/" + app.id } className="grid-item app-item" key={app.id} >
      <img className="app-image" alt={app.displayName + " image"} src={
        (app.image == null)
        ? './None.png'
        : app.image
      } />
      <div className="app-details">
        <h3>{app.displayName}</h3>
        <p class="subtitle">{app.bundle}</p>
        <VersionList versions={app.versions} />
      </div>
    </Link>
  ))

 return (
   <>
     {apps}
   </>
 )
}


function VersionList(props){
  if(props.versions.length > 0){
    return (
      <p>{props.versions[0].versionNumber}</p>
    )
  } else {
    return (
      <p>-</p>
    )
  }
}

export default AppsIndex;
